module.exports = __webpack_public_path__ + "media/components/src/assets/images/embellishments/points/point_07-b34885fe88f43dc8e229696614295c22.svg";